import useLayout from '@/composables/useLayout';
import { watch } from '@vue/composition-api';
import { getDefaultGroup, getGroupId, pureGetMatchedGroupId, setGroupId } from '../../utils';
import { useBaseInfo } from './useBaseInfo';
export function useAutoUpdateGroupId() {
    const { visibleSidebarGroups } = useLayout();
    const { options } = useBaseInfo();
    watch(() => [options.value, visibleSidebarGroups.value], ([optionsData, groupsData]) => {
        const lastGroupId = getGroupId();
        const groups = groupsData.slice();
        const cuIdx = groups.findIndex(item => item.groupId === lastGroupId);
        // 当前没有选中或选中的应用组在第一位则无需调整顺序
        if (cuIdx > 0) {
            const [curGroup] = groups.splice(cuIdx, 1);
            groups.unshift(curGroup);
        }
        const currentGroupId = pureGetMatchedGroupId(groups, optionsData) || getDefaultGroup()?.groupId;
        setGroupId(currentGroupId);
    });
}
